<template>
  <div>
    <el-popover
      placement="top-start"
      width="200"
      trigger="hover"
      v-if="value.length"
    >
      <div v-for="item,index in  value" :key="index">
        <span style="font-weight:700">{{getName(item.type)}}： </span>
        <span v-for="name,nameIndex in item.code" :key="nameIndex">
          {{name.brandName}} <i v-if="nameIndex !== item.code.length - 1">,</i>
        </span>
      </div>
      <div slot="reference">
        <div v-for="item,index in  value" :key="index" class="text-overflow" >
        {{getName(item.type)}}<span v-if="item.type !== '01'">：</span>
        <span v-for="name,nameIndex in item.code" :key="nameIndex">
          {{name.brandName}}
        </span>
      </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    title: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: ''
    }
  },

  data () {
    return {

    }
  },
  created () {
    // console.log(this.value)
  },
  methods: {
    getName (val) {
      let name = ''
      switch (val) {
        case '01':
          name = '全部'
          break
        case '02':
          name = 'SegMent'
          break
        case '03':
          name = '品牌'
          break
        case '04':
          name = '子品牌'
          break
        case '05':
          name = 'SKU'
          break
      }
      return name
    }
  }
}
</script>

<style lang="scss" scoped>
.text-overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-orient: vertical;
  line-clamp: 1;
  cursor: pointer;
}
</style>
